import React from 'react';
import { createStyles, Theme, makeStyles } from '@material-ui/core/styles';

// material
import { Drawer, List, ListItem, ListItemIcon, ListItemText } from '@material-ui/core';
import { Inbox } from '@material-ui/icons';

// entites
import { Auth } from '../../../entities/auth';

import store from '../../../store';

interface NavItem {
    name: string;
    role: string[];
    link: string;
}

const drawerWidth = 240;
const navItems: NavItem[] = [
    {
        name: 'Admin Home',
        role: ['admin', 'superadmin', 'textadmin'],
        link: '/admin'
    },
    {
        name: 'Leads',
        role: ['admin', 'superadmin'],
        link: '/admin/leads'
    },
    {
        name: 'Campaigns All',
        role: ['admin', 'superadmin'],
        link: '/admin/campaigns'
    },
    {
        name: 'Campaigns',
        role: ['admin', 'superadmin', 'textadmin'],
        link: '/admin/campaigns/run'
    },
    {
        name: 'Organizations',
        role: ['admin', 'superadmin', 'orgadmin'],
        link: '/organizations'
    },
    {
        name: 'Templates',
        role: ['admin', 'superadmin', 'textadmin'],
        link: '/admin/templates'
    },
    {
        name: 'Users',
        role: ['superadmin'],
        link: '/admin/users'
    },
    {
        name: 'Addresses',
        role: ['superadmin'],
        link: '/admin/addresses'
    },
    {
        name: 'Logs',
        role: ['admin', 'superadmin'],
        link: '/admin/logs'
    }
];
const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            display: 'flex',
        },
        appBar: {
            width: `calc(100% - ${drawerWidth}px)`,
            marginLeft: drawerWidth,
        },
        drawer: {
            width: drawerWidth,
            flexShrink: 0,
        },
        drawerPaper: {
            marginTop: 60,
            width: drawerWidth,
        },
        toolbar: theme.mixins.toolbar,
        content: {
            flexGrow: 1,
            backgroundColor: theme.palette.background.default,
            padding: theme.spacing(3),
        },
    }),
);

interface AdminNavProps {
    auth: Auth;
    onClick(link: string): void;
}

const AdminNav = (props: AdminNavProps) => {

    const classes = useStyles({});

    const hasRole = (navRoles: string[]) => {
        const reduxStore: any = store.getState();
        const rolesStr = (reduxStore.auth.auth && reduxStore.auth.auth.user ? reduxStore.auth.auth.user.role : null);
        const roles = (rolesStr ? rolesStr.split(',') : []);

        let hasAccess = false;
        roles.forEach((role: string) => {
            const roleCheck = navRoles.indexOf(role.trim());
            if (roleCheck !== -1) {
                hasAccess = true;
            }
        });
        return hasAccess;
    }

    return (
        <List>
            { navItems.map((item: NavItem, index: number) => {
                return hasRole(item.role) ? <ListItem button key={`item-${index}`} onClick={() => props.onClick(item.link)}>
                    <ListItemIcon><Inbox /></ListItemIcon>
                    <ListItemText primary={item.name} />
                </ListItem> : null
            })}
        </List>
    );
}

export default AdminNav;



// WEBPACK FOOTER //
// ./src/pages/admin/components/AdminNav.tsx